import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { HttpClientModule} from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
/*import { NgxImageZoomModule } from 'ngx-image-zoom';*/
/*import {ImageZoomModule} from 'angular2-image-zoom';*/
/*import {ImageZoomModule} from 'ng2-image-hover-zoom';*/

import { MatInputModule, MatButtonModule, MatCardModule, MatMenuModule, MatToolbarModule, MatIconModule, MatProgressBarModule} from '@angular/material';

import { AppComponent } from './app.component';
import { NavbarComponent } from './navbar/navbar.component';
import { AlertComponent } from './alert/alert.component';
import { InputPassHideComponent } from './input-pass-hide/input-pass-hide.component';
import { RankingComponent } from './ranking/ranking.component';

/*ROUTES*/
import { routes } from './app.routers';
import { SelectComponent } from './select/select.component';
import { StoggleComponent } from './stoggle/stoggle.component';

/*PAGES*/
import { StoreComponent } from './pages/store/store.component';
import { DetailsComponent } from './pages/details/details.component';
import { CategoryComponent } from './pages/category/category.component';
import { HeaderComponent } from './section/header/header.component';
import { FooterComponent } from './section/footer/footer.component';
import { InventoryComponent } from './pages/inventory/inventory.component';
import { LoginComponent } from './pages/login/login.component';

/*Services*/
import { BaseCoreServiceModule } from './services/core/base-core-module'
import { ProductService } from './services/product.service';

@NgModule({
  declarations: [
    AppComponent,    
    NavbarComponent,    
    AlertComponent,
    SelectComponent,
    StoggleComponent,
    InputPassHideComponent,    
    StoreComponent, RankingComponent, DetailsComponent,
    CategoryComponent, HeaderComponent, FooterComponent, 
    InventoryComponent, LoginComponent
  ],
  imports: [
    routes,
    HttpClientModule,
    BrowserAnimationsModule,
    MatInputModule, MatButtonModule, MatCardModule, MatMenuModule, MatToolbarModule, MatIconModule, MatProgressBarModule,
    BrowserModule, FormsModule, HttpModule, InfiniteScrollModule,
    BaseCoreServiceModule
    /*,NgxImageZoomModule.forRoot()*/
  ],
  providers: [
    ProductService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/app.module.ts